<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-12 16:16:52
-->
<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.name"
                    size="mini"
                    clearable
                    placeholder="请输入昵称"
                />
            </div>
            <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.phone"
                    size="mini"
                    clearable
                    placeholder="请输入电话"
                />
            </div>
            <div class="shaixuan-item">
                <el-button
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    @click="searchClick()"
                    icon="el-icon-search"
                >
                    查询
                </el-button>
                <!-- <el-button
                    @click="clickItem(0)"
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    icon="el-icon-plus"
                >
                    新增
                </el-button> -->
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table
                v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px"
            >
                <el-table-column prop="id" label="id" width="180" />
                <el-table-column prop="nickname" label="昵称" width="200" />
                <el-table-column prop="phone" label="电话" width="200" />
                <el-table-column label="头像" width="200" >
                    <template slot-scope="scope">
                        <el-image
                            style="width: 100px; height: 100px"
                            :src="$adddom(scope.row.avatar)"
                            :preview-src-list="[$adddom(scope.row.avatar)]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="门禁照片" width="200" >
                    <template slot-scope="scope">
                        <el-image
                            style="width: 100px; height: 100px"
                            :src="$adddom(scope.row.photo)"
                            :preview-src-list="[$adddom(scope.row.photo)]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="admin" label="状态">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="0"
                            @change="changeStatus(scope.row,1)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
              <el-table-column prop="admin" label="绑定白名单">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.white_status"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeStatus(scope.row,2)"
                  >
                  </el-switch>
                </template>
              </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <el-button
                                type="danger"
                                @click="resource(scope.row)"
                                style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                                >用户资源</el-button
                            >
                            <!--<el-button-->
                              <!--type="danger"-->
                              <!--@click="jifenshezhi(scope.row)"-->
                              <!--style="-->
                                      <!--background: rgb(224 112 16);-->
                                      <!--border-color: rgb(224 112 16);-->
                                  <!--"-->
                            <!--&gt;积分信息</el-button-->
                            <!--&gt;-->
                            <el-button
                                type="danger"
                                @click="remove(scope.row)"
                                style="
                                    background: #ff4949;
                                    border-color: #ff4949;
                                "
                                >删除</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination
                v-show="total"
                :total="total"
                :page.sync="queryParam.page"
                :limit.sync="queryParam.size"
                @pagination="getList"
            />
        </div>
        <!-- 积分分配抽屉 -->
      <el-drawer custom-class="custom-drawer" :visible.sync="showDrawer" :close-on-press-escape="false"
                 :wrapper-closable="false" :show-close="false" size="770px" v-loading="draLoading">
        <template slot="title">
          <div class="custom-title">
            <div class="title-name">积分信息</div>
            <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
          </div>
        </template>
        <div class="custom-content">
          <el-form ref="ruleForm" :model="viewData" :rules="rules" label-width="100px">
            <el-form-item label="手机号：">
              <div>{{viewData.phone}}</div>
            </el-form-item>
            <el-form-item label="总积分：">
              <div>{{viewData.totalScore}}</div>
            </el-form-item>
            <el-form-item label="分积分：">
              <div style="display: flex;justify-content: space-between">
                <div>物业：{{viewData.wuyejifen}}</div>
                <div>食堂：{{viewData.yinbaojifen}}</div>
                <div>商城：{{viewData.youzanjifen}}</div>
              </div>
            </el-form-item>
            <el-divider content-position="left"></el-divider>
            <el-form-item label="积分调整：">
              <el-select v-model="viewData.kind" clearable filterable placeholder="正数为增加，负数为减少" style="width: 130px;">
                <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="数量">
              <el-input-number v-model="viewData.num" @change="handleChange" :min="-9999999" :max="9999999" label="积分数量"></el-input-number>
            </el-form-item>
            <el-tag type="success" style="margin-left: 100px">正数为增加积分，负数为减少积分</el-tag>
          </el-form>
          <div style="width: 100%;background: #FFFFFF;-webkit-box-shadow: 0px 5px 16px 0px rgba(123, 123, 123, 0.1);box-shadow: 0px 5px 16px 0px rgba(123, 123, 123, 0.1);z-index: 10;
    left: 0;
    bottom: 0;padding: 20px;display: -webkit-box;display: -ms-flexbox;display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;">
            <el-button style="
                            min-width: 117px;
                            background: #1067e0;
                            font-size: 16px;
                            border-color: #1067e0;
                        " size="mini" type="primary" @click="submit()">提交</el-button>
          </div>
          <el-divider content-position="left"></el-divider>
          <div style="padding-left: 5%">
            <el-table
              v-loading="listLoading2"
              :data="tableData2"
              size="mini"
              style="width: 90%; min-height: 300px"
            >
              <el-table-column prop="id" label="id" width="80" />
              <el-table-column prop="user_points" label="物业" width="80" />
              <el-table-column prop="yinbao_points" label="食堂" width="80" />
              <el-table-column prop="youzan_points" label="商城" width="80" />
              <el-table-column prop="typeString" label="类型" width="80" />
              <el-table-column prop="created_at" label="时间" width="90" />
              <el-table-column prop="sourceString" label="来源" width="150" />
            </el-table>
            <pagination
              v-show="total2"
              :total="total2"
              :page.sync="queryParam2.page"
              :limit.sync="queryParam2.size"
              @pagination="getList2"
            />
          </div>
        </div>
      </el-drawer>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/member";
import Qu from "@/api/tianzheng/Qu";
import commonAdd from "./memberAdd.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            tableData2:[],
            listLoading2:false,
            draLoading:false,
            total2:0,
            queryParam2 :{
              name: "",
              phone: "",
              page: 1,
              size: 10,
            },
            optionList: [],
            queryParam: {
                name: "",
                phone: "",
                page: 1,
                size: 10,
            },
            statusList:[
              {
                value:'wuye',
                label:'物业'
              },{
                value:'youzan',
                label:'商城'
              },
              {
                value:'yinbao',
                label:'食堂'
              }
              ],
            total: 0,
            listLoading: false,
            tableData: [],
            isEdit: 0, // 0新增 1编辑
            showDrawer: false,
            viewData:{
                id:0,
                kind:'wuye',
                num:0,
                totalScore:0,
              wuyejifen:0,
              yinbaojifen:0,
              youzanjifen:0,
            },
            rules:{},
            jifenList:[],
        };
    },
    components: {
        Pagination,
        commonAdd,
    },
    created() {},
    mounted() {
        this.getList();
        // this.getSelectCity()
    },
    methods: {
        handleChange(value) {
          this.viewData.num = value;
        },
        jifenshezhi(row){
          console.log(row.id);
          this.showDrawer = true;
          this.viewData.id = row.id;
          var params={
            id:this.viewData.id,
          };
          fetch.detail(params).then((res) => {
            if (res.code == 200) {
              this.viewData = res.result
            }
          });
          this.getList2();
        },
        submit(){
          this.draLoading = true;
          var params={
            id:this.viewData.id,
            kind:this.viewData.kind,
            num:this.viewData.num,
          };
          fetch.jiaJianJiFen(params).then((res) => {
            if (res.code == 200) {
              this.draLoading = false;
              this.$message.success("操作成功");
              this.viewData.kind="";
              this.viewData.num=0;
              this.jifenshezhi(this.viewData);
            } else {
              this.draLoading = false;
              this.$message.error(res.message);
            }
          });
        },
        resource(row){
            console.log(row.id)
            this.$router.push({
                path: '/member/memberResource?id='+row.id
            })
        },
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        /**
         * @name: 更改状态
         * @param {*} val
         * @return {*}
         * @desc:
         */
        changeStatus(val,type) {
             let curstatus = type ==2?val.white_status:val.status;
            let params = {
                id: val.id,
                status: curstatus,
                type : type,
            };

            fetch.status(params).then((res) => {
                if (res.code == 200) {
                    this.$message.success("操作成功");
                    this.getList();
                } else {
                    this.getList();
                    this.$message.error(res.message);
                }
            });
        },
        // 更新弹层状态
        onUpdateDrawer(status) {
            console.log("status", status);
            if (status == 1) {
                // 成功
                this.showDrawer = false;
                this.getList();
            } else if (status == -1) {
                // 失败
                this.showDrawer = false;
            }
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showDrawer = false;
            // this.$refs.commonAdd.resetForm();
        },
        /**
         * @name: 点击子项 0新增 1编辑
         * @param {*} type
         * @param {*} id
         * @return {*}
         * @desc:
         */
        clickItem(type, row) {
            let that = this;
            this.showDrawer = true;
            this.isEdit = type;
            // 给组件传值
            let obj = {
                type: type,
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.commonAdd.initFun(obj);
            });
        },
        /* 查询按钮，页码重置，查询数据 */
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        /* 查询tableData数据 */
        getList() {
        let that = this;
        this.listLoading = true;
        fetch.list(that.queryParam).then((res) => {
          that.listLoading = false;
          that.tableData = res.result.list;
          that.total = res.result.total;
        });
      },
      getList2() {
        let that = this;
        this.listLoading2 = true;
        this.queryParam2.id = this.viewData.id;
        fetch.jifenList(that.queryParam2).then((res) => {
          that.listLoading2 = false;
          that.tableData2 = res.result.list;
          console.log(this.tableData2)
          that.total2 = res.result.total;
        });
      },
        remove(row) {
            let that = this;
            that.$confirm("确定删除该内容吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // 调用接口
                    fetch.remove({ id: row.id }).then((res) => {
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.getList();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
